<template>
    <div v-if="complete || rejected">
        <!-- 全員確認済みの場合 -->
        <v-icon x-large>{{ icon }}</v-icon>
    </div>
    <div v-else-if="contractError == 1">
        <!-- 契約エラーの場合 -->
        <v-icon x-large class="alert">{{ icon }}</v-icon>
        <div class="alert" :style="{ fontSize: fontSize + 'px'}">送信エラー</div>
    </div>
    <div v-else>
        <v-progress-circular :rotate="-90" :value="percent"></v-progress-circular>
        <div :style="{ fontSize: fontSize + 'px'}">{{ progress }}</div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                complete: false,
                percent: 0,
                progress: null,
                icon : "mdi-check-circle-outline",
            }
        },
        props: {
            fontSize: {
                type: String,
                default: "15",
            },
            // 分子
            agreeCnt: {
                type: Number,
                default: "0",
            },
            // 分母
            allCnt: {
                type: Number,
                default: "0",
            },
            // 却下
            rejected: {
                type: Boolean,
                default: false
            },
            // 契約エラー
            contractError:  {
                type: Number,
                default: 0
            },
        },
        computed: {
            'status'() {
                return [this.agreeCnt, this.allCnt, this.rejected];
            }
        },
        watch: {
            'status': {
                immediate: true,
                handler: function (next) {
                    this.setIcon(); // createdやmountedだとページ切替時に呼ばれないため
                }                
            }
        },
        methods: {
            setIcon() {
                if (this.rejected) {
                    // 却下の時
                    this.icon = "mdi-close-circle-outline";
                    return;
                } else if (this.contractError == 1) {
                    this.icon = "mdi-alert-circle-outline";
                    return;
                }
                
                this.complete = this.agreeCnt != 0 && this.agreeCnt == this.allCnt;
                if (this.complete || (this.allCnt == 0)) {
                    // 全員確認済みの場合か0割の場合は処理中断
                    return;
                }
                // 何分のいくつか表示
                this.progress = this.agreeCnt + "/" + this.allCnt;
                // 進捗具合の計算
                this.percent = 100 * this.agreeCnt / this.allCnt;
            }
        }
    }
</script>
<style scoped>
    .alert {
        color: red;
    }
</style>